import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { LuMailCheck } from "react-icons/lu";
import { Brand, Field, Note } from "../components/Ui";

const ENDPOINT = "https://us-east1-foursssolutions.cloudfunctions.net/send_activation_link_v2";

export default function ReactivateLink() {
  const navigate = useNavigate();
  const { apiToken, resetEmail } = useSelector((s) => s.profile);

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [countdown, setCountdown] = useState(5);
  const intervalRef = useRef(null);
  const delayRef = useRef(null);

  /* prefill from redux resetEmail (legacy displayed this value in the input) */
  useEffect(() => {
    setEmail(resetEmail || "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* clear any pending countdown / delayed handler on unmount */
  useEffect(
    () => () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      if (delayRef.current) clearTimeout(delayRef.current);
    },
    []
  );

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      /* same endpoint, headers and payload as legacy */
      const response = await fetch(ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiToken}`,
        },
        body: JSON.stringify({
          task: "resend_activation_link",
          user_mail: email,
        }),
      });
      const data = await response.json();
      /* legacy handled the result behind a 4-second delay */
      delayRef.current = setTimeout(() => {
        setLoading(false);
        if (response.ok) {
          setSent(true);
          intervalRef.current = setInterval(() => {
            setCountdown((prev) => {
              if (prev === 1) {
                clearInterval(intervalRef.current);
                navigate("/login");
              }
              return prev - 1;
            });
          }, 1000);
        } else {
          setError(`Verification failed: ${data.status}`);
        }
      }, 4000);
    } catch (err) {
      setLoading(false);
      setError("An error occurred while sending the activation link. Please try again.");
    }
  }

  return (
    <div className="csx">
      <div className="csx-page">
        <div className="auth-main" style={{ flex: 1 }}>
          <Brand />
          <div className="auth-card stack-3">
            <div className="stack-2">
              <h1 className="t-h1">Request a new activation link</h1>
              <p className="t-sm">
                The activation link has expired. Use the button below to request a new verification link.
              </p>
            </div>

            {sent ? (
              <Note tone="accent">
                <LuMailCheck size={17} />
                <span>
                  A new email with the activation link has been sent. Check your inbox and click the link to
                  activate your account. Redirecting to{" "}
                  <Link to="/login" style={{ fontWeight: 600, textDecoration: "underline", color: "inherit" }}>
                    sign in
                  </Link>{" "}
                  in {countdown} seconds.
                </span>
              </Note>
            ) : null}
            {error ? (
              <Note tone="danger">
                <span>{error} You can try again below.</span>
              </Note>
            ) : null}

            <form className="stack-3" onSubmit={handleSubmit} noValidate>
              <Field label="Email">
                <input
                  className="input"
                  type="email"
                  autoComplete="username"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Field>
              <button
                type="submit"
                className="btn btn-primary btn-lg btn-full"
                disabled={loading || sent}
              >
                {loading ? <span className="spinner" /> : null}
                Reactivate profile
              </button>
            </form>

            <p className="t-sm t-center">
              <Link to="/login" className="t-accent" style={{ fontWeight: 600 }}>
                Go to sign in
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
